export interface GenreCount { genre: string; count: number }

/**
 * The most common genres among these songs, most songs first (ties by name so the order never flickers),
 * ignoring songs without a genre. Used for the "Top genre" cards on the Music page, which change as the
 * playlist changes.
 */
export function topGenres(songs: ReadonlyArray<{ genre?: string | null }>, limit = 2): GenreCount[] {
  const counts = new Map<string, number>();
  for (const s of songs) {
    const genre = (s.genre ?? '').trim();
    if (!genre) continue;
    counts.set(genre, (counts.get(genre) ?? 0) + 1);
  }
  return [...counts.entries()]
    .map(([genre, count]) => ({ genre, count }))
    .sort((a, b) => b.count - a.count || a.genre.localeCompare(b.genre))
    .slice(0, limit);
}

export const songCountLabel = (count: number): string => `${count} ${count === 1 ? 'song' : 'songs'}`;
